import * as React from "react";
import { Link } from "../../atoms/Link";
import logo from "../../../images/logo.svg";
import { BlueskyIcon, EmailIcon, LinkedInIcon, XIcon } from "../icons";
import {
  LANG_FR_BE,
  requestADemoPath,
} from "../../../constants";

const navigation = {
  legal: [
    { name: "CGU", href: "/be/terms" },
    { name: "Données personnelles", href: "/be/data-privacy" },
  ],
  contact: [
    { name: "Demander une démo", href: requestADemoPath(LANG_FR_BE) },
    { name: "contact@omnidoc.be", href: "mailto:contact@omnidoc.be" },
  ],
  social: [
    {
      name: "Linkedin",
      href: "https://www.linkedin.com/company/omnidocapp",
      icon: LinkedInIcon,
    },
    {
      name: "Bluesky",
      href: "https://bsky.app/profile/did:plc:z34pritos7y5pammf3doztb7",
      icon: BlueskyIcon,
    },
    {
      name: "X",
      href: "https://x.com/omnidoc_app",
      icon: XIcon,
    },
    {
      name: "Email",
      href: "mailto:contact@omnidoc.be",
      icon: EmailIcon,
    },
  ],
};

export const Footer = (
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="xl:grid xl:grid-cols-3 xl:gap-8">
      <div className="space-y-8 xl:col-span-1">
        <img
          className="h-4 w-auto sm:h-4 mb-0"
          src={logo}
          alt="Omnidoc, plateforme de télé-expertise"
        />
        <p className="text-gray-500 text-base max-w-prose">
          Omnidoc est une société indépendante créée en 2019 et entièrement
          dédiée au développement de sa solution de téléexpertise et à sa prise
          en main par les professionnels de santé.
        </p>
        <div className="flex space-x-6">
          {navigation.social.map(item => (
            <Link
              key={item.name}
              to={item.href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-gray-500"
            >
              <span className="sr-only">{item.name}</span>
              <item.icon className="h-5 w-5" aria-hidden="true" />
            </Link>
          ))}
        </div>
      </div>
      <div className="mt-12 grid grid-cols-2 gap-8 xl:mt-0 xl:col-span-2">
        <div className="md:grid md:grid-cols-2 md:gap-8">
          <div className="mt-12 md:mt-0">
            <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">
              Confidentialité
            </h3>
            <ul className="mt-4 space-y-4">
              {navigation.legal.map(item => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-base text-gray-500 hover:text-gray-900"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="md:grid md:grid-cols-2 md:gap-8">
          <div className="mt-12 md:mt-0">
            <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">
              Nous contacter
            </h3>
            <ul className="mt-4 space-y-4">
              {navigation.contact.map(item => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-base text-gray-500 hover:text-gray-900"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
);
